import React from 'react';
import { components as SelectComponents } from 'react-select';
import { SelectComponentsConfig } from 'react-select/lib/components';
import { CaretDownIcon, CloseIcon } from '@tanium/react-graphics';
import { createMultiValuePill } from './createMultiValuePill';
import { createValueContainer } from './createValueContainer';
import { useTranslation } from './localization';
import { SelectSize } from './types';

interface GetComponentsParams {
  size: SelectSize;
  isMultiCollapsible: boolean;
  enablePillsMaxWidth?: boolean;
}

export const getComponents = ({
  size,
  isMultiCollapsible,
  enablePillsMaxWidth = true,
}: GetComponentsParams) => {
  const indicatorSize = size === 'sm' ? 9 : 12;

  return {
    IndicatorSeparator: () => <>{null}</>,
    DropdownIndicator: (props) =>
      SelectComponents.DropdownIndicator && (
        <SelectComponents.DropdownIndicator {...props}>
          <CaretDownIcon width={indicatorSize} height={indicatorSize} />
        </SelectComponents.DropdownIndicator>
      ),
    ClearIndicator: (props) => {
      const { t } = useTranslation();
      return (
        SelectComponents.ClearIndicator && (
          <SelectComponents.ClearIndicator {...props}>
            <CloseIcon aria-label={t('Clear')} height={16} width={16} />
          </SelectComponents.ClearIndicator>
        )
      );
    },
    MultiValue: createMultiValuePill(size, enablePillsMaxWidth),
    ValueContainer: createValueContainer(isMultiCollapsible),
  } as SelectComponentsConfig<any>; // eslint-disable-line @typescript-eslint/no-explicit-any
};
